export enum PaymentType {
  SEPA = 'SEPA',
}

export interface PaymentInfo {
  iban: string;
  bic: string;
  bankName: string;
}
